import { render, staticRenderFns } from "./sxjhlist.vue?vue&type=template&id=7a2154c6&scoped=true&"
import script from "./sxjhlist.vue?vue&type=script&lang=js&"
export * from "./sxjhlist.vue?vue&type=script&lang=js&"
import style0 from "./sxjhlist.vue?vue&type=style&index=0&id=7a2154c6&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2154c6",
  null
  
)

export default component.exports